module.exports = __webpack_public_path__ + "static/media/slide-4.fc7b7da7.jpg";